import 'regenerator-runtime/runtime';
import { all } from 'redux-saga/effects';
import { shopTarifierungVHV } from './shopTarifierungVHV';
import { watchVersicherungssummenTrigger } from './versicherungssummenSaga';
import { watchWertsachensummenTrigger } from './wertsachensummenSaga';
import { streckenTarifierungVHV } from './streckenTarifierungVHV';
import { watchStateSnapshot } from './stateSnapshotSaga';
import { watchproduktlinienSaga } from './produktlinienSaga';
import { watchDruckdatenChanged } from './druckdatenSaga';
import { watchInDashboardUebernehmenSaga } from './inDashboardUebernehmenSaga';
import { watchAntragsnummerRequested } from './antragsnummerSaga';
import { watchVorschlagdatenChanged } from './vorschlagdatenSaga';
import { watchQuoteDB } from './quoteDbSaga';
import { watchStreckeSnapshot } from './streckeSnapshotSaga';
import { watchVorbelegungRequested } from './vorbelegungSaga';
import { watchBeibehaltungProduktRequested } from './beibehaltungProduktSaga';
import { handleVhvNavigationToAngebotSaga } from './handleVhvNavigationToAngebotSaga';
import { updateRisikoortAfterLoadAzamSaga } from './updateRisikoortAfterLoadAzamSaga';
import { extremwetterschutzVorbelegenSaga } from './extremwetterschutzVorbelegenSaga';
import { extremwetterschutzSelbstbeteiligungSaga } from './extremwetterschutzSelbstbeteiligungSaga';
import { watchFahrradEntschaedigungsgrenzeTrigger } from './fahrradEntschaedigungsgrenzeSaga';
import { watchResetAdressdatenRequested } from './resetAdressdatenSaga';
import { watchVorvertragVorschaedenRequested } from './vorvertragVorschaedenSaga';
import { watchReevaluateUwRequirednessAfterLoad } from './reevaluateUwRequirednessAfterLoadSaga';
import { watchConfirmUwApprovedOfferEdition } from './confirmUwApprovedOfferEditionSaga';

export function* rootSaga() {
  yield all([
    watchAntragsnummerRequested(),
    shopTarifierungVHV(),
    watchVorschlagdatenChanged(),
    watchVersicherungssummenTrigger(),
    watchWertsachensummenTrigger(),
    streckenTarifierungVHV(),
    watchStateSnapshot(),
    watchStreckeSnapshot(),
    watchproduktlinienSaga(),
    watchDruckdatenChanged(),
    watchInDashboardUebernehmenSaga(),
    watchQuoteDB(),
    watchVorbelegungRequested(),
    watchBeibehaltungProduktRequested(),
    handleVhvNavigationToAngebotSaga(),
    updateRisikoortAfterLoadAzamSaga(),
    extremwetterschutzVorbelegenSaga(),
    extremwetterschutzSelbstbeteiligungSaga(),
    watchFahrradEntschaedigungsgrenzeTrigger(),
    watchResetAdressdatenRequested(),
    watchVorvertragVorschaedenRequested(),
    watchReevaluateUwRequirednessAfterLoad(),
    watchConfirmUwApprovedOfferEdition(),
  ]);
}
